import React, { Component } from 'react';
import CusSearchBar from '../antd/CusSearchBar';
import { Ticon, DateRangeOnlyModal } from 'tplus-components-mobile';
import './SearchView.less';
import { autobind } from 'core-decorators';
import { observer } from 'mobx-react';
import { DatePicker } from 'antd-mobile';
import { tools } from 'tplus-voucher';

@observer
class SearchView extends Component {

    constructor(props) {
        super(props);
        let { model, searchTypes, filterConfig } = props;
        let hold = searchTypes[model.filterCondition.searchType].hold;
        let filterCondition = { startDate: model.BeginDate || '', endDate: model.EndDate || '' };
        filterConfig.forEach(item => {
            if (model.filterCondition[item.key]) {
                filterCondition[item.key] = item.content.filter(it => it.value == model.filterCondition[item.key]);
            } else {
                filterCondition[item.key] = item.defaultValue;
            }
        })
        if (model.BeginDate || model.EndDate) {
            filterCondition.dateRange = [{ value: '7', label: '自定义' }];
        }
        this.state = {
            placeholder: hold,
            showFilterContent: false,
            type: '',
            filterCondition,
            showUserDateRangeSelector: model.BeginDate || model.EndDate || false, // 显示用户自定义日期选择器
            startDate: model.BeginDate, // 用来渲染日期控件的
            endDate: model.EndDate,
            _startDate: model.BeginDate, // 用来请求数据的日期
            _endDate: model.EndDate,
            visibleUserDateRangeSelector: false,
            date: '' // 收款到期日
        }
    }



    //清空
    @autobind
    clear() {
        this.search('');
    }
    //搜索
    search = (value) => {
        let { model } = this.props;
        model.search(value);
    }

    //左侧按钮点击
    @autobind
    handleClick(buttonIndex) {
        //选择搜索类型
        let { model, searchTypes } = this.props;
        if (buttonIndex < searchTypes.length - 1 && buttonIndex > -1) {
            model.searchType = buttonIndex;
            this.setState({
                placeholder: searchTypes[model.searchType].hold
            });
        }
    }

    onFilterAllClick = (type, e) => {
        e.stopPropagation();
        if (this.props.model.filterDisabeldCondition.find(item => item.key == type)) { // 如果是被禁止的条件
            return;
        }
        if (type == this.state.type) {
            this.setState({
                showFilterContent: !this.state.showFilterContent
            })
        } else {
            this.setState({
                showFilterContent: true,
                type
            })
        }

    }

    onFilterItemClick = (value, e) => {
        let filterCondition = this.state.filterCondition;
        filterCondition[this.state.type] = [value];
        if(this.state.type == 'dateRange' && value.value != 7) {
            filterCondition.startDate = '';
            filterCondition.endDate = '';
            this.setState({
                _startDate: '',
                _endDate: ''
            })
        }
        this.setState({
            filterCondition
        })
        // 延时关闭
        setTimeout(() => {
            this.setState({
                showFilterContent: false
            })
        }, 200)
        if (filterCondition.dateRange[0].value == 7) {
            this.setState({
                showUserDateRangeSelector: true
            })
            // return false;
        } else {
            this.setState({
                showUserDateRangeSelector: false
            })
        }
        filterCondition = { ...filterCondition };

        this.props.model.filterDisabeldCondition && this.props.model.filterDisabeldCondition.forEach(item => {
            // filterCondition.delete(item.key)
            delete filterCondition[item.key];
        })
        // 点击的是 查看范围中的选项，清空关键字
        if (this.state.type == 'searchType') {
            // 清空本地的
            this.searchBar && this.searchBar.textChange('');
        }
        this.props.simpleSearch && this.props.simpleSearch(filterCondition);

        e.stopPropagation();
        return false;
    }

    backgroundClick = () => {
        this.setState({
            showFilterContent: false
        })
    }

    getFilterTitle = (type) => {
        let title = this.state.filterCondition[type][0]['label'];

        // 如果过滤条件是全部，就显示各自的title
        title = title == '全部' ? this.props.filterConfig.find(it => it.key == type).title : title;
        title = this.props.model.filterDisabeldCondition.find(item => item.key == type) ? this.props.model.filterDisabeldCondition.find(item => item.key == type).label : title
        return title;
    }

    onDateChange = (startDate, endDate) => {
        console.log(startDate, endDate);
        this.setState({
            startDate,
            endDate
        })
        if (startDate && endDate) {
            let { filterCondition } = this.state;

            filterCondition = {
                ...filterCondition,
                startDate,
                endDate,
                dateRange: [{ value: '7', label: '自定义' }]
            }
            this.setState({
                _startDate: startDate,
                _endDate: endDate,
                filterCondition
            })
            this.props.simpleSearch && this.props.simpleSearch(filterCondition);
            setTimeout(() => {
                this.setState({
                    visibleUserDateRangeSelector: false,
                    startDate: '',
                    endDate: ''
                })
            }, 200)
        }
    }

    onDateClose = () => {
        this.setState({
            visibleUserDateRangeSelector: false
        })
    }

    onDateOpen = () => {
        this.setState({
            visibleUserDateRangeSelector: true
        })
    }

    // 收款到期日 日期改变 查询
    datePickerOnChange = (date) => {
        date = tools.dateFormat(date);
        this.setState({ date });
        this.search(date);
    }

    clearDate = (e) => {
        e.stopPropagation();
        this.setState({
            date: ''
        })
        this.datePickerOnChange('');
    }

    render() {
        let { showFilterContent, type, filterCondition, showUserDateRangeSelector, visibleUserDateRangeSelector, startDate, endDate, _startDate, _endDate } = this.state;
        let { model, searchTypes, filterConfig } = this.props;
        let hold = searchTypes[model.filterCondition.searchType].hold;
        let InputSearchType = searchTypes[model.filterCondition.searchType].type;
        let item = searchTypes[model.filterCondition.searchType];
        let defaultFilterItem = { content: [], title: '', top: '0.45rem', defaultValue: [{ value: '' }] };
        let filterItem = filterConfig.find(it => it.key == type) || defaultFilterItem;
        let filterItemValue = filterCondition[type || 'searchType'][0]['value'];
        return (
            <div className='SearchView'>
                <div className='search'>
                    <div className='SearchBar' onClick={this.backgroundClick}>
                        {/* 查看范围是写死的 */}
                        <div className='customer-filter' onClick={this.onFilterAllClick.bind(this, 'searchType')}>{this.getFilterTitle('searchType')}
                            <Ticon type='zhankaitubiao1' className='search-filter-icon' />
                        </div>
                        {
                            InputSearchType == 'date' ?
                                <React.Fragment>
                                    <DatePicker
                                        mode="date"
                                        extra="Optional"
                                        value={new Date(this.state.date || tools.dateFormat(new Date()))}
                                        onChange={this.datePickerOnChange}
                                    >
                                        {/* <List.Item arrow="horizontal">Date</List.Item> */}
                                        <div className={`date-input ${this.state.date ? '' : 'date-input-placeholder'}`}>{this.state.date || hold}</div>

                                    </DatePicker>
                                    {this.state.date && <Ticon type='guanbi' className='guanbi-icon' onClick={this.clearDate} />}
                                </React.Fragment>
                                :
                                <CusSearchBar
                                    ref={searchBar => this.searchBar = searchBar}
                                    searchKey={'orderList'}
                                    search={this.search}
                                    clear={this.clear}
                                    placeholder={hold || ''}>
                                </CusSearchBar>
                        }
                    </div>
                </div>
                <div className='search-filter-group'>
                    {
                        filterConfig.filter(item => item.key !== 'searchType').map(item => {
                            let disabled = false;
                            if (this.props.model.filterDisabeldCondition.find(it => it.key == item.key)) { // 如果是被禁止的条件
                                disabled = true;
                            }
                            return (
                                <div className={`filter-item ${disabled? 'disabled': ''}`} onClick={this.onFilterAllClick.bind(this, item.key)}>{this.getFilterTitle(item.key)}
                                    <Ticon type='zhankaitubiao1' className='search-filter-icon' />
                                </div>
                            )
                        })
                    }
                </div>

                <div className='search-filter-content' onClick={this.backgroundClick} style={{ display: showFilterContent ? 'block' : 'none', top: filterItem.top }}>
                    <div className='content' onClick={e => e.stopPropagation()}>
                        <div className='header'>
                            {
                                filterItem.content.map(item => {
                                    return (
                                        <div key={item.label} className={`content-item ${item.value == filterItemValue ? 'content-item-actived' : ''}`} onClick={this.onFilterItemClick.bind(this, item)}>{item.label}</div>
                                    )
                                })
                            }
                            <div className='content-item other-item'></div>
                            <div className='content-item other-item'></div>
                            <div className='content-item other-item'></div>
                        </div>
                    </div>
                </div>

                {
                    showUserDateRangeSelector ?
                        <React.Fragment>
                            <div onClick={this.onDateOpen} className='dateRangeBar'>
                                <div className={`dateRangeBar-startDate dateRangeBar-date ${_startDate ? 'dateValuable' : ''}`}>{_startDate || '开始时间'}</div>
                                <div className='dateRangeBar-text'>至</div>
                                <div className={`dateRangeBar-endDate dateRangeBar-date ${_endDate ? 'dateValuable' : ''}`}>{_endDate || '结束时间'}</div>
                            </div>
                            <DateRangeOnlyModal visible={visibleUserDateRangeSelector} onChange={this.onDateChange} onClose={this.onDateClose} startDate={startDate} endDate={endDate} />
                        </React.Fragment>
                        :
                        null
                }

                <div className='search-listView'>
                    {this.props.children}
                </div>
            </div>

        );
    }
}

export default SearchView;